module.exports = {
  ENVIRONMENT: "prod",
  WEBSITE_DOMAIN: "http://bi.123-ai.cn",
  LOGIN_DOMAIN: "https://login.123-ai.cn",
  SME_DOMAIN: "https://bi.123-ai.cn",
  TMS_DOMAIN: "https://tms.123-ai.cn",
  AMB_DOMAIN: "https://amb.123-ai.cn",
  FMS_DOMAIN: "https://fms.123-ai.cn",
  PSI_DOMAIN: "https://psi.123-ai.cn",
  OA_DOMAIN: "https://oa.123-ai.cn",
  CRM_DOMAIN: "https://crm.123-ai.cn",
  JAVA_BASE_ADDR: "https://bi.123-ai.cn/api2"
};
